<script setup></script>
<template>
  <svg
    width="556"
    height="556"
    viewBox="0 0 556 556"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="556" height="556" rx="278" fill="#03876C" />
    <path
      d="M122 221C173.5 58.5 382.5 58.5 432 221"
      stroke="#EFF4F3"
      stroke-width="24"
      stroke-linecap="round"
    />
    <path
      d="M161 290.604H178.722C179.925 290.604 181.013 291.323 181.483 292.431L188.974 310.065C190.054 312.609 193.708 312.463 194.581 309.841L213.037 254.43C213.944 251.706 217.792 251.69 218.722 254.406L239.905 316.302C240.763 318.809 244.212 319.054 245.416 316.695L257.898 292.24C258.41 291.236 259.443 290.604 260.57 290.604H289.8C291.013 290.604 292.107 291.334 292.571 292.454L302.084 315.392C303.156 317.979 306.874 317.816 307.716 315.146L326.723 254.882C327.6 252.103 331.524 252.08 332.434 254.848L352.608 316.198C353.439 318.726 356.906 319.001 358.125 316.635L370.702 292.229C371.217 291.231 372.246 290.604 373.369 290.604H393"
      stroke="#EFF4F3"
      stroke-width="17"
      stroke-linecap="round"
    />
    <path
      d="M173.781 258C169.725 230.797 181.027 197.035 218 209.772"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M218.6 209.336C204.929 185.227 218.6 169.011 234.847 169.011M234.847 169.011C237.014 169.233 234.182 168.942 234.847 169.011ZM234.847 169.011C292.614 169.011 250.186 220 278 220"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M382.219 258C386.275 230.797 374.973 197.035 338 209.772"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M337.4 209.336C351.071 185.227 337.4 169.011 321.153 169.011M321.153 169.011C318.986 169.233 321.818 168.942 321.153 169.011ZM321.153 169.011C263.386 169.011 305.814 220 278 220"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M173.781 331C169.725 358.203 181.027 391.965 218 379.228"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M218.6 378.873C204.929 403.455 218.6 419.989 234.847 419.989M234.847 419.989C237.014 419.762 234.182 420.059 234.847 419.989ZM234.847 419.989C292.614 419.989 250.186 368 278 368"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M382.202 331C386.348 358.203 374.795 391.965 337 379.228"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M336.486 378.873C349.947 403.455 336.486 419.989 320.489 419.989M320.489 419.989C318.355 419.762 321.144 420.059 320.489 419.989ZM320.489 419.989C263.611 419.989 305.386 368 278 368"
      stroke="#CEFBE8"
      stroke-width="16"
      stroke-linecap="round"
    />
    <path
      d="M110 278L110 338"
      stroke="#EFF4F3"
      stroke-width="65"
      stroke-linecap="round"
    />
    <line
      x1="443.5"
      y1="277.5"
      x2="443.5"
      y2="337.5"
      stroke="#EFF4F3"
      stroke-width="65"
      stroke-linecap="round"
    />
  </svg>
</template>
